import React, { useState } from "react";
import "../../styles/login.scss";
import { Route, Navigate ,useNavigate } from 'react-router-dom';
import axios from "axios";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";
import LoginLogo from "../../images/Cyber security.svg"
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotPassword() {
  const dispatch = useDispatch();
  const [string, setString] = useState("");
    const [errormsg, setErrorMsg] = useState("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  var regex = new RegExp(/[@]/g);
  let boolen = regex.test(string);
  const [EmailID, setEmailID] = useState("");
  const data = boolen ? { email: string } : { username: string };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (EmailID.trim() === "") {
      setErrorMsg("Please enter the email.");
      return;
    }

    if (!emailPattern.test(EmailID)) {
      setErrorMsg("Please enter a valid email.");
      return;
    }
    try {
      const resp = await axios.put("v1/auth/forgotpassword", data, {
        headers: { "content-type": "application/json" }
      });
      if (resp.status === 200) {
        dispatch(loginReducer.Forget_password(false));
        toast.success(resp.data.data, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (err) {
      // console.log(err);
      
      toast.error(err.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  
  const [buttonclickd, setButtonclickddd] = useState(false);

  const navigate = useNavigate();
  const validateinput = () => {
    if (EmailID == "") {
      setErrorMsg("Please enter Email.");
    } else if (EmailID !== "") {
      const inputElement = document.getElementById("EmailID");
      console.log(inputElement)
      const inputValue = inputElement.value;
      const sanitizedValue = inputValue.replace(/\s/g, "");
      inputElement.value = sanitizedValue;
      setErrorMsg("");
      setButtonclickddd(true);
    }
  };
  return (
    <div className="login-container">
      
          <div
            className="container-fluid login-background"
            style={{
              overflow: "auto"
            }}
          >
              <div className="row">
              <img
                className="Login-title"
                src={require("../../images/LoginTitle.png")}
                alt=""
              ></img>
            </div>
            <div className="row">
              <div className=" col-lg-5 text-center col-sm-12 col-one">
                <div >
            <form onSubmit={handleSubmit}>
           
              <div className="welcomeback">Forgot Password ?</div>
              <div className="mailtxt">
                Enter the email address <br></br>associated with your account
              </div>
              <Box
                //component="form"
                sx={{
                  "& > :not(style)": {
                    m: 1,
                    width: "459px",
                    marginLeft: "30px"
                  }
                }}
                noValidate
                autoComplete="off"
              >
                <div className="label-items">Email ID</div>
                <TextField
                   id="EmailID"
                   value={EmailID}
                  placeholder="Enter Email ID"
                  variant="outlined"
                  type={boolen ? "email" : "text"}
                  autoComplete="off"
                  InputLabelProps={{ shrink: false, sx: { color: "#8F8D8D" } }}
                  sx={{
                    '& .MuiOutlinedInput-root':{
                      background:"#F9F8F4",
                      border:"1px solid #334456",
                      borderRadius:"10px"
                    },
                    "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                      {
                        "& > fieldset": {
                          borderColor: "#334456", 
                          
                        }
                      }
                  }}
                  InputProps={{
                    style: {
                  
                      height: "47px",
                      color: "#171616"
                    }
                  }}
                  maxLength={"15"}
                  required
           
                  onChange={(e) => {
                    const { value } = e.target;
                    setString(value);
                    setEmailID(value);
                 
        
                  }}
                
                />
              </Box>
           
          
              <div className="submit-cancel">
              <button className="signupbtn" type="submit"  onClick={validateinput} >
                Generate Password
              </button>
              <button
                className="signupbtn"
                
                onClick={() => {
                  dispatch(loginReducer.Forget_password(false));
                  setEmailID(""); 

                  // navigate('/login');
                }}
              >
                Cancel
              </button>
              
             
              </div>
              {errormsg && (
                  <p className="error-forgot">{errormsg}</p>
                )}
             
              <div
                  
                  className="back-login"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Back to login
                </div>
            </form>
      
          </div>
        </div>
        <div className="col-lg-1 col-md-12 col-sm-12"></div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-two">
          <img
            style={{ width: "90%", padding:"15px" }}
            src={LoginLogo}
            alt="TATA Elxsi"
          ></img>
        </div>
      </div>
    </div>
    </div>
  );
}

export default ForgotPassword;
